import type { UserRole, UserRoleAssignment } from '@/types';

export function getActiveRoles(roles?: UserRoleAssignment[]): UserRole[] {
  if (!roles) return [];
  return roles
    .filter(r => r && r.isActive)
    .map(r => r.role);
}

export function hasRole(roles: UserRoleAssignment[] | undefined, role: UserRole): boolean {
  if (!roles) return false;
  return roles.some(r => r.role === role && r.isActive);
}

export function validateRoleAssignment(roles: UserRoleAssignment[]): UserRoleAssignment[] {
  // Remove duplicates keeping only the most recent assignment
  const uniqueRoles = roles.reduce((acc: UserRoleAssignment[], curr) => {
    const existingIndex = acc.findIndex(r => r.role === curr.role);
    if (existingIndex >= 0) {
      // Keep the most recent one
      if (curr.assignedAt > acc[existingIndex].assignedAt) {
        acc[existingIndex] = curr;
      }
    } else {
      acc.push(curr);
    }
    return acc;
  }, []);

  return uniqueRoles;
}